import GiftCardSection from '@activities/prepaidCard/PrepaidCardGiftDetailActivity/components/GiftCardSection';
import GiftDetailFooter from '@activities/prepaidCard/PrepaidCardGiftDetailActivity/components/GiftDetailFooter';
import GiftInfoSection from '@activities/prepaidCard/PrepaidCardGiftDetailActivity/components/GiftInfoSection';
import Column from '@components/Column';
import CtaLayout from '@components/CtaLayout';
import Header from '@components/Header';
import Loading from '@components/Loading';
import PrepaidCardNotes from '@components/prepaid/PrepaidCardNotes';
import TermNotes from '@components/term/TermNotes';
import styled from '@emotion/styled';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import usePrepaidGiftDetail from './hooks/usePrepaidGiftDetail';

interface Params {
    giftBoxId: string;
}

declare module '@stackflow/config' {
    interface Register {
        PrepaidCardGiftDetailActivity: Params;
    }
}

const PrepaidCardGiftDetailActivity: ActivityComponentType<'PrepaidCardGiftDetailActivity'> = ({
    params,
}) => {
    const { giftBoxId } = params;
    const { t } = useTranslation('prepaidCard');
    const { gift, isLoading } = usePrepaidGiftDetail(giftBoxId);

    return (
        <AppScreen>
            <CtaLayout
                header={<Header title={t('giftDetail.title')} />}
                footer={gift ? <GiftDetailFooter gift={gift} /> : null}
                noFooterBorder>
                {isLoading && <Loading size='small' />}
                {gift && (
                    <>
                        <Wrapper fullWidth>
                            <GiftCardInfoWrapper fullWidth spacing={4}>
                                <GiftCardSection gift={gift} />
                                <GiftInfoSection gift={gift} />
                            </GiftCardInfoWrapper>
                            <PrepaidCardNotes noMargin />
                            {/* <TermNotes displayContext='PREPAY' variant='body' /> */}
                        </Wrapper>
                    </>
                )}
            </CtaLayout>
        </AppScreen>
    );
};

const Wrapper = styled(Column)`
    background-color: var(--color-gray1);
    padding: 0 0 calc(80px + var(--safe-area-bottom));
    flex: 1;
`;

const GiftCardInfoWrapper = styled(Column)`
    padding: 16px;
`;

export default PrepaidCardGiftDetailActivity;
